const msClarityProjectIds = [
    { 'com': 'hdlmwkjurh' },
    { 'de': 'hip7j3jhyx' },
    { 'fr': 'inadubqdvo' },
];

class MSClarity {
    constructor({ env }) {
        this._isProduction = env.isProduction;
        this.init();
    }

    init() {
        const tld = window.location.host.split('.').pop();
        const msClarityProjectId = msClarityProjectIds[tld];

        if (!this._isProduction || !msClarityProjectId) {
            return;
        }

        // If MS Clarity already loaded, do nothing.
        if (document.getElementById('msClarity')) {
            return;
        }

        this.addMSClarity(msClarityProjectId);
    }

    // Adds MS Clarity script to the beginning of the <head>
    addMSClarity(projectID) {
        let script = document.createElement('script');
        script.id = 'msClarity';
        script.innerHTML = `
        (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${projectID}");
        `;
        document.head.prepend(script);
    }

    trackAmplitudeExperimentInClarity(isVariant, amplitudeExperimentFlagKey) {
        if (typeof window.clarity === 'function') {
            const variantType = isVariant ? 'Variant' : 'Control';
            window.clarity('set', amplitudeExperimentFlagKey, variantType);
        }
    }
}

export default (nuxt) => new MSClarity(nuxt);
